module.exports = __webpack_public_path__ + "img/refresh2.c6a7c3a7.png";